import { connect } from 'scrivito'

import { AsyncSelect } from '@/Atomic/Molecules/Inputs/Select/AsyncSelect'
import { FieldMap } from '@/utils/CRUD/read/dataItem/types'
import { getReferenceDataItem } from '@/utils/CRUD/read/reference/getDataItem'
import { getDataItemTitle } from '@/utils/dataClassMap'

interface ConnectedReferenceFieldProps {
  name: string
  label?: string
  requirementState?: 'required' | 'optional'
  value: unknown
  displayValue?: string
  fieldSchema: FieldMap['fieldSchema']
  onChange: (...event: unknown[]) => void
  loadReferenceOptions?: (
    inputValue: string,
  ) => Promise<{ label: string; value: string }[]>
  className?: string
  isReadonly?: boolean
  error?: string
}

/**
 * Reference-specific wrapper around AsyncSelect.
 * Keeps the initial Scrivito reference lookup inside a connected render context
 * so the label can be resolved without "Content not yet loaded" errors.
 */
export const ConnectedReferenceField: React.FC<ConnectedReferenceFieldProps> =
  connect(
    ({
      name,
      label,
      requirementState,
      value,
      displayValue,
      fieldSchema,
      onChange,
      loadReferenceOptions,
      className,
      isReadonly,
      error,
    }) => {
      const referencedDataItem = getReferenceDataItem(fieldSchema, value)
      const referencedTitle = referencedDataItem
        ? (getDataItemTitle(referencedDataItem) ?? undefined)
        : undefined

      return (
        <AsyncSelect
          name={name}
          label={label}
          requirementState={requirementState}
          displayValue={displayValue ?? referencedTitle}
          value={value}
          onChange={onChange}
          loadReferenceOptions={loadReferenceOptions}
          className={className}
          isDisabled={isReadonly}
          error={error}
        />
      )
    },
  )
